export const ADD_AUDIT_MESSAGES = 'ADD_AUDIT_MESSAGES';
export const SHOW_AUDIT_MESSAGE_LIST = 'SHOW_AUDIT_MESSAGE_LIST';